export default __webpack_public_path__ + "static/media/GS_LOGO.80be93b2.svg";